import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import {
  Form,
  Input,
  Button,
  Select,
  Row,
  Col,
  Switch,
  DatePicker,
  Upload,
  message,
  Checkbox,
  List,
  Typography,
  Space,
  Dropdown,
  Menu,
  Card,
  Tag,
  Table as AntdTable,
  InputNumber,
  Radio,
  Alert,
} from 'antd';
import IntlMessages from '@iso/components/utility/intlMessages';
import FormModalWrapper from './FormModal.styles';
import { configs } from '@iso/components/Tables/configs';
import {
  CheckCircleFilled,
  ExclamationCircleFilled,
  UploadOutlined,
  MinusCircleOutlined,
  PlusOutlined,
  EditOutlined,
  UserOutlined,
  DownOutlined,
  SendOutlined,
  EllipsisOutlined
} from '@ant-design/icons';
import {
  propertyService,
  userService,
  permissionService,
  formService,
  userFormService,
  surveyQuestionService,
  globalFormService,
  categoryGlobalFormService,
  visitorFormService,
  profileService,
  propertyHostService
} from '@iso/services';
import { bakeHostDefaults } from '@iso/constants/libraryFieldWidgets';
import { visitorInductionService } from '@iso/services';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import $ from 'jquery';
import Loader from '@iso/components/utility/loader';
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';
import { dateHelper } from '@iso/lib/helpers/dateHelper';
import { formTypes } from '@iso/constants/formTypes';
import { FORM_PURPOSES, isInductionPurpose } from '@iso/constants/formPurposes';
import { getSafetyAssetsForCategory } from '@iso/constants/safetyAssetTypes';
import SchemaPreviewModal from '@iso/containers/Pages/AdminPages/ManageLibraryForms/PreviewFormModal';
import LibraryFormBuilderDrawer from '@iso/containers/Pages/AdminPages/ManageLibraryForms/LibraryFormBuilderDrawer';
import SelectFromLibraryModal from './SelectFromLibraryModal';
import moment from "moment";
import * as Survey from "survey-react";
import "survey-react/survey.css";
import "survey-react/modern.css";
import ViewSurveyResultModal from './ViewSurveyResultModal';
import Question from './Question';
import SignatureCanvas from 'react-signature-canvas';
import { surveyQuestionTypes } from '@iso/constants/surveyQuestionTypes';
import {visitorTypes} from '@iso/constants/visitorTypes';
import QRCode from "react-qr-code";
import PreviewFormModal from './PreviewFormModal';
import FormBuilder from 'antd-form-builder';
import GlobalForm from './GlobalForm'
import FinalScreen from './FinalScreen'
import BioForm from '@iso/containers/Pages/AdminPages/FormBuilder/BioForm/BioForm';
import PreviewFormTemplate from './PreviewFormTemplate';
import CheckinForm from '@iso/containers/Pages/AdminPages/FormBuilder/CheckinForm/CheckinForm';
import HazardForm from '@iso/containers/Pages/AdminPages/FormBuilder/HazardForm/HazardForm';
import { Link } from 'react-router-dom';
import Table from '@iso/components/collapsing-table/table';
import VisitorModal from '@iso/containers/Pages/Visitor/VisitorModal';
import Box from "@iso/components/utility/box";
import CheckinUserProfileModal from "@iso/containers/Pages/Profile/CheckinUserProfileModal";
import { useForm } from 'antd/lib/form/Form';
import TrainingForm from '@iso/containers/Pages/AdminPages/FormBuilder/TrainingForm/TrainingForm';
import IllnessForm from '@iso/containers/Pages/AdminPages/FormBuilder/IllnessForm/IllnessForm';
import NearMissForm from '@iso/containers/Pages/AdminPages/FormBuilder/NearMissForm/NearMissForm';
import QuestionFields from './QuestionFields';

const { Option } = Select;
const { Paragraph } = Typography;
Survey.StylesManager.applyTheme("modern");

// Controlled Form.Item child for picking a library template via modal.
const LibraryTemplatePickerControl = ({
  value,
  disabled,
  templates,
  editedSchema,
  onOpenPicker,
  onPreview,
  onEdit,
}) => {
  const selectedTpl = (templates || []).find((t) => t.id === value);
  const selectedName =
    (editedSchema && editedSchema.name) ||
    (selectedTpl && selectedTpl.name) ||
    null;
  return (
    <div>
      <Button size="large" block disabled={disabled} onClick={onOpenPicker}>
        Select from Library
      </Button>
      {selectedName && (
        <div style={{ marginTop: 8 }}>
          <Tag color="geekblue">{selectedName}</Tag>
        </div>
      )}
      {editedSchema && (
        <div style={{ textAlign: 'right', marginTop: 4 }}>
          <Button type="link" onClick={onPreview}>
            Preview
          </Button>
          <Button type="link" onClick={onEdit}>
            Edit standalone form
          </Button>
        </div>
      )}
    </div>
  );
};

// Canonical Form Categories shown first (in this order) in the Form Category
// dropdown; any other library categories load after them. Seeded by migration
// m260710_000003 so each has a real category_global_form_id.
const FIXED_CATEGORY_ORDER = [
  'Check-In & Attendance',
  'Inductions',
  'Pre-Starts',
  'Risk Assessments',
  'Hazards & Observations',
  'Incidents & Near Misses',
  'Inspections & Audits',
  'Vehicles, Plant & Equipment',
  'Chemicals & Dangerous Goods',
  'Livestock & Biosecurity',
  'Training & Toolbox Talks',
  'Health, Welfare & Emergency',
  'Environmental & Weather',
  'Operations & Maintenance',
  'Policies, Permits & Compliance',
];

const FormModal = (props) => {
  const padRef = useRef({});
  const activePropertyId = useSelector((state) => state.property.activePropertyId);
  const currentUser = useSelector((state) => state.user.user);
  const [loading, setLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [dataList, setDataList] = useState({});
  const [dataForm, setDataForm] = useState({});
  const [form] = Form.useForm();
  const permissions = useSelector(state => state.permission.permissions);
  // Owner/admin of the property manage its forms, so they get the sharing panel
  // on every form — not just the ones they created. The backend list now shows
  // them all of the property's forms; without this they could see a form whose
  // sharing they had no way to correct.
  const activePermission = useSelector((state) => state.permission.activePermission);
  const isPropertyManager = activePermission === 'owner' || activePermission === 'admin';
  const [showForm, setShowForm] = useState(false);
  const [fields, setFields] = useState([]);
  const [fileId, setFileId] = useState(null);
  const [userProperty, setUserProperty] = useState([]);
  const [userChecked, setUserChecked] = useState(false);
  const [userInviteList, setUserInviteList] = useState([]);
  const [userFormList, setUserFormList] = useState([]);
  const [visitorFormList, setVisitorFormList] = useState([]);
  const [surveyDataSubmit, setSurveyDataSubmit] = useState({});
  const [visibleViewSurveyResult, setVisibleViewSurveyResult] = useState(false);
  const [surveyResult, setSurveyResult] = useState({});
  // Phase 07 — submissions of a dynamic (schema_json) form, listed by time.
  const [schemaSubmissions, setSchemaSubmissions] = useState([]);
  // Induction forms this property can embed. Same source Run Induction uses, so
  // the selector can only ever offer something that is actually runnable.
  const [inductionForms, setInductionForms] = useState([]);
  const [loadingInductionForms, setLoadingInductionForms] = useState(false);
  const [signatureUrl, setSignatureUrl] = useState("");
  const [surveyQuestions, setSurveyQuestions] = useState({});
  const [surveyContent, setSurveyContent] = useState({});
  const [questionList, setQuestionList] = useState([]);
  const [isShowQr, setIsShowQr] = useState(false);
  const [livedForms, setLivedForms] = useState([]);
  const [schemaTemplates, setSchemaTemplates] = useState([]);
  const [formCategories, setFormCategories] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [libraryPickerVisible, setLibraryPickerVisible] = useState(false);
  const [schemaPreview, setSchemaPreview] = useState({ visible: false, form: null });
  // Local, unsaved customization of the selected library template's schema. When set,
  // its schema_json is submitted with the form (overriding the template copy).
  const [editedSchema, setEditedSchema] = useState(null);
  const [builderVisible, setBuilderVisible] = useState(false);
  // Property hosts (Manage Hosts data) — the default host set baked into any
  // unconfigured "List Hosts" field so it shows all hosts (see reconcile effect).
  const [propertyHosts, setPropertyHosts] = useState([]);
  // Documentation & Training categories — tagging a form places it in that
  // Safety Documents category alongside the tagged assets.
  const safetyDocTags = useMemo(() => getSafetyAssetsForCategory("documentation_training"), []);
  // Stable seed for the builder drawer — a fresh object literal each render would
  // reset the drawer's in-progress edits on any FormModal re-render. The standalone
  // copy (editedSchema) is the single source of truth; carries NO library id, so
  // the builder can never target/overwrite the template.
  const builderSeed = useMemo(() => (editedSchema ? {
    name: editedSchema.name,
    schema_json: editedSchema.schema_json,
  } : null), [editedSchema]);

  // A form created BEFORE the Form Library system has no library category. Editing
  // such a form shows the OLD UI (Form Type + survey/preview) and keeps working
  // exactly as before; only NEW forms use the Category/Style/Purpose fields.
  const isLegacyForm = !!(dataForm && dataForm.id && !dataForm.category_global_form_id);

  // A dynamic (library / schema_json) form uses the new schema engine + the
  // Phase 07 unified submission store. Its results are listed by time via
  // GET /forms/<id>/submissions (see loader below).
  const isSchemaForm = !!(
    dataForm &&
    dataForm.schema_json &&
    Array.isArray(dataForm.schema_json.steps) &&
    dataForm.schema_json.steps.length
  );

  // Load this schema form's submissions (newest first) for View Result.
  useEffect(() => {
    if (!dataForm || !dataForm.id || !isSchemaForm) {
      setSchemaSubmissions([]);
      return;
    }
    formService.getSubmissions(dataForm.id).then((res) => {
      if (res && res.code === '0000') {
        setSchemaSubmissions(res.submissions || []);
      }
    });
  }, [dataForm, isSchemaForm]);

  // Only a check-in form can embed an induction, so only then is the list worth
  // fetching.
  useEffect(() => {
    if (!props.propertyId) {
      setInductionForms([]);
      return;
    }
    setLoadingInductionForms(true);
    visitorInductionService
      .getAvailableForms(props.propertyId)
      .then((res) => {
        setInductionForms((res && res.success && res.data && res.data.forms) || []);
      })
      .catch(() => setInductionForms([]))
      .finally(() => setLoadingInductionForms(false));
  }, [props.propertyId]);

  // Load the property's hosts (Manage Hosts data) so unconfigured List Hosts fields
  // can default to showing all of them.
  useEffect(() => {
    if (!props.propertyId) {
      return;
    }
    propertyHostService.getAdmins(props.propertyId).then((res) => {
      if (res && res.code === '0000') {
        setPropertyHosts(res.data || []);
      }
    });
  }, [props.propertyId]);


  // Keep the standalone schema's List Hosts fields defaulted to "show all hosts":
  // whenever hosts load or the schema changes, bake the full host set into any host
  // field the author hasn't curated. bakeHostDefaults returns the same reference
  // when nothing changes, so this settles in one pass (no loop).
  useEffect(() => {
    // Skip while the builder is open so a late host load can't reset in-progress
    // edits; the submit-time bake is the backstop.
    if (builderVisible || !editedSchema || !editedSchema.schema_json || !propertyHosts.length) {
      return;
    }
    const baked = bakeHostDefaults(editedSchema.schema_json, propertyHosts);
    if (baked !== editedSchema.schema_json) {
      setEditedSchema((prev) => (prev ? { ...prev, schema_json: baked } : prev));
    }
  }, [propertyHosts, editedSchema, builderVisible]);

  const [isVisiblePreviewModal, setIsVisiblePreviewModal] = useState(false);
  const [showFinalScreen, setShowFinalScreen] = useState(false)
  const [visibleVisitorModal, setVisibleVisitorModal] = React.useState(false);
  const [visitor, setVisitor] = React.useState({});
  const [visibleCheckinUserProfileModal, setVisibleCheckinUserProfileModal] = React.useState(false);
  const [checkinUserId, setCheckinUserId] = React.useState(null);

  const [selectedVisitorTypes, setSelectedVisitorTypes] = useState([]);
  const [visibility, setVisibility] = useState([]);
  const [surveyQuestionType, setSurveyQuestionType] = useState([]);
  const { TextArea } = Input;

  const [formFields, setFormFields] = useState({
      columns: 1,
      formItemLayout: null, 
      fields: []
  });
  const [globalForm, setGlobalForm] = useState([]);
  const [categoryGlobalForm, setCategoryGlobalForm] = useState({});
  const dateFormat = 'DD/MM/YYYY';
  const formRef = React.createRef()
  const [systemForm] = Form.useForm()

  useEffect(() => {
    if(props.propertyId, dataForm.id){
      surveyQuestionService.getList(dataForm.id).then(res => {
        if(res.code === '0000'){
          let questions = [];
          _.forEach(res.survey_questions, (question, index) => {
            switch(question.question_type){
              case 'yes/no':
                var data = {
                  name: "page_" + question.id,
                  questions: [
                    {
                      type: "radiogroup",
                      choices: ["Yes", "No"],
                      isRequired: question.meta_data.response_required,
                      name: (question.id).toString(),
                      title: question.title
                    }
                  ]
                };
                break;
              case 'text':
                var data = {
                  name: "page_" + question.id,
                  questions: [
                    {
                      type: "text",
                      isRequired: question.meta_data.response_required,
                      name: (question.id).toString(),
                      title: question.title
                    }
                  ]
                };
                break;
              case 'multiple_choice':
                var data = {
                  name: "page_" + question.id,
                  questions: [
                    {
                      type: "radiogroup",
                      choices: question.options,
                      isRequired: question.meta_data.response_required,
                      name: (question.id).toString(),
                      title: question.title
                    }
                  ]
                };
                break;
              case 'signature':
                var data = {
                  name: "page_" + question.id,
                  questions: [
                    {
                      type: "signaturepad",
                      isRequired: question.meta_data.response_required,
                      name: (question.id).toString(),
                      title: question.title
                    }
                  ]
                };
                break;
              case 'multi_selection':
                var data = {
                  name: "page_" + question.id,
                  questions: [
                    {
                      type: "checkbox",
                      choices: question.options,
                      isRequired: question.meta_data.response_required,
                      name: (question.id).toString(),
                      title: question.title
                    }
                  ]
                };
                break;
              case 'number':
                var data = {
                  name: "page_" + question.id,
                  questions: [
                    {
                      type: "number",
                      isRequired: question.meta_data.response_required,
                      name: (question.id).toString(),
                      title: question.title
                    }
                  ]
                };
                break;
              case 'scale':
                var data = {
                  name: "page_" + question.id,
                  questions: [
                    {
                      type: "radiogroup",
                      choices: ["Strongly Disagree", "Disagree", "Neutral", "Agree", "Strongly Agree"],
                      isRequired: question.meta_data.response_required,
                      name: (question.id).toString(),
                      title: question.title
                    }
                  ]
                };
                break;
              case 'upload_file':
                var data = {
                  name: "page_" + question.id,
                  questions: [
                    {
                      type: "file",
                      isRequired: question.meta_data.response_required,
                      name: (question.id).toString(),
                      title: question.title
                    }
                  ]
                };
                break;
              default:
                var data = {
                  name: "page_" + question.id,
                  questions: [
                    {
                      type: "comment",
                      isRequired: question.meta_data.response_required,
                      name: (question.id).toString(),
                      title: question.title
                    }
                  ]
                };
                break;
            }

            questions.push(data);
          });
          setQuestionList(questions);
        }
      });
    }    
    
  },[props.propertyId, dataForm])

  useEffect(() => {
    if(questionList && dataForm)
    {
      var surveyJSON = {
        title: dataForm.survey_title,
        description: dataForm.survey_description,
        completedHtml: "<h3>Thank you for completing the survey!</h3> <h5>Please click Save to submit your survey!</h5>",
        pages: questionList
      }

      setSurveyContent(surveyJSON);
    } 
  }, [questionList, dataForm])

  const cancelModal = () => {
    props.cancelModal();
    form.resetFields();
    setUserInviteList([]);
    setSurveyDataSubmit({});
    setLoading(false);
    setEditedSchema(null);
    setBuilderVisible(false);
  }

  const renderOptionsFormType = () => {
    // Canonical categories first (fixed order), then any other library categories.
    const orderIndex = (name) => {
      const i = FIXED_CATEGORY_ORDER.indexOf(name);
      return i === -1 ? FIXED_CATEGORY_ORDER.length + 1 : i;
    };
    const sorted = [...formCategories].sort((a, b) => {
      const diff = orderIndex(a.name) - orderIndex(b.name);
      return diff !== 0 ? diff : (a.name || '').localeCompare(b.name || '');
    });
    return (
      <Select
        placeholder="Select a form category"
        allowClear
        showSearch
        optionFilterProp="children"
        size="large"
        disabled={dataForm.id ? true : false}
        onChange={handleChangeLivedForm}
      >
        {sorted.map((cat) => (
          <Option key={cat.id} value={cat.id}>{cat.name}</Option>
        ))}
      </Select>
    );
  }

  // Apply a published library template as a STANDALONE copy for this property form.
  // Deep-clone so later template edits never touch it, and editing it never touches
  // the template. Switching re-clones.
  const applyLibraryTemplate = (tpl) => {
    const current = form.getFieldValue('form') || {};
    // Default the Form Category to the template's category when the author hasn't
    // picked one yet; keep any category they've already selected.
    const nextCategoryId = current.category_global_form_id
      ? current.category_global_form_id
      : (tpl ? tpl.category_global_form_id : current.category_global_form_id);
    const nextCategory = formCategories.find((c) => c.id === nextCategoryId);
    form.setFieldsValue({
      form: {
        ...current,
        global_form_id: tpl ? tpl.id : null,
        // Default the Form Name to the template's name when the author hasn't
        // typed one yet; keep any name they've already entered.
        name: current.name ? current.name : (tpl ? tpl.name : current.name),
        category_global_form_id: nextCategoryId,
        is_checkin_form: nextCategory ? isCheckinCategory(nextCategory.name) : false,
      },
    });
    // Keep the check-in flag / Select-from-Library category filter in sync with
    // the (possibly auto-filled) category.
    setSelectedCategoryId(nextCategoryId || null);
    if (tpl && tpl.schema_json && Array.isArray(tpl.schema_json.steps)) {
      setEditedSchema({
        name: tpl.name,
        schema_json: JSON.parse(JSON.stringify(tpl.schema_json)),
      });
    } else {
      setEditedSchema(null);
    }
  };

  const handleSelectFromLibrary = (tpl) => {
    applyLibraryTemplate(tpl);
    // Keep the parent cache in sync so the selected name resolves immediately.
    setSchemaTemplates((prev) => (
      prev.some((t) => t.id === tpl.id) ? prev : [...prev, tpl]
    ));
    setLibraryPickerVisible(false);
  };

  const getLivedForms = () => {
    categoryGlobalFormService.getLivedForms().then(res => {
        if(res.code === '0000'){
          setLivedForms(res.category_global_form);
        }
    })
    // Library templates (schema library). Uses the non-admin-gated published list
    // (get-lived-forms) so property owners/admins can resolve the selected template
    // name when editing; the picker modal also loads this list itself.
    globalFormService.getLivedForms().then(res => {
      if (res && res.code === '0000') {
        setSchemaTemplates(res.global_forms || []);
      }
    })
    // Form Category options come from the Form Categories managed in Manage Library
    // Of Forms (open read endpoint). A category named "Check-In Form" marks the form
    // as a check-in form (drives the public QR).
    categoryGlobalFormService.get().then(res => {
      if (res && res.code === '0000') {
        setFormCategories(res.category_global_form || []);
      }
    })
  }

  // A category whose name reads as "Check-In" flags the form as a check-in form.
  const isCheckinCategory = (name) => /check\s*-?\s*in/i.test(name || '');

  const handleChangeLivedForm = (value) => {
    // value = selected Form Category id. Reflect the check-in flag so the check-in
    // survey config (visitor types, hosts) shows when a "Check-In" category is picked.
    // Also used as the default Category filter in Select from Library.
    setSelectedCategoryId(value || null);
    const cat = formCategories.find((c) => c.id === value);
    const current = form.getFieldValue('form') || {};
    form.setFieldsValue({ form: { ...current, is_checkin_form: cat ? isCheckinCategory(cat.name) : false } });
  }

  useEffect(() => {
    if(props.propertyId){
       userService.getUserByProperty(props.propertyId, currentUser.id).then(res => {
        if(res.code === '0000'){
          let result = [];
          _.forEach(res.user_property, (user, index) => {
            result.push({
                "label" : user.name + ' (' + user.email + ')',
                "value" : user.id
              }
            )
          });
          setUserProperty(result);
        }
      });
    }
  }, [props.propertyId, dataForm]);

  useEffect(() => {
    if(dataForm && dataForm.id){
      setShowFinalScreen(false);
       userFormService.getList(dataForm.id).then(res => {
        if(res.code === '0000'){
          setUserFormList(res.user_form);

          checkShowFinalScreen(res.user_form);
          // console.log('res.user_form',res.user_form);

        }
      });
      getVisitorForms()
    }
  }, [props.propertyId, dataForm]);

  const getVisitorForms = () => {
    if (dataForm) {
      visitorFormService.getList(dataForm.id).then((res) => {
        if (res.code === "0000") {
          // The list no longer embeds the (identical) form on every row — it comes
          // once as res.form to keep the payload small. Re-attach it to each row so
          // View Result (row.form.type / row.form.schema_json) keeps working. Fall
          // back to the form already loaded in the modal if res.form is absent.
          const sharedForm = res.form || dataForm || null;
          const rows = (res.visitor_forms || []).map((row) =>
            row.form ? row : { ...row, form: sharedForm }
          );
          setVisitorFormList(rows);
        }
      }); 
    }
  }

  const checkShowFinalScreen = (data) => {
    if(data.length > 0){
       _.forEach(data, (value, index) => {
        if(value.user_id == currentUser.id && value.global_form_submission){
          setShowFinalScreen(true);
        }
      });  
    }
  }

  const getFormData = (formId) => {
    categoryGlobalFormService.view(formId).then(res => {

      if(res.code === '0000'){
        // if(res.global_form.meta_fields) setFormFields(res.global_form.meta_fields);
        setGlobalForm(res.category_global_form.globalForms);
        setCategoryGlobalForm(res.category_global_form);
        // console.log(res.category_global_form.globalForms);
      }
    })
  }

  useEffect(() => {
    if(props.formData){
      setDataForm(props.formData);
      // Seed the default Category filter for Select from Library on edit.
      setSelectedCategoryId(props.formData.category_global_form_id || null);
      // When editing a form that already has a standalone schema, load it so it can
      // be edited via "Edit standalone form" and re-submitted (isolated from the
      // library template it was cloned from).
      if (props.formData.schema_json && Array.isArray(props.formData.schema_json.steps) && props.formData.schema_json.steps.length) {
        setEditedSchema({ name: props.formData.name, schema_json: props.formData.schema_json });
      }

      var fieldList = [
        {
          name: ['form', 'name'],
          value: dataForm.name || '',
        },
        {
          name: ['form', 'date'],
          value: dataForm.date ? moment(props.formData.date) : moment(),
        },
        {
          name: ['form', 'is_public'],
          value: dataForm.is_public,
        },
        {
          name: ['form', 'is_online'],
          value: dataForm.is_online ? true : false,
        },
        {
          name: ['form', 'is_share_all'],
          value: dataForm.is_share_all,
        },
        {
          name: ['form', 'survey_title'],
          value: dataForm.survey_title,
        },
        {
          name: ['form', 'survey_description'],
          value: dataForm.survey_description,
        },
        {
          name: ['form', 'category_global_form_id'],
          value: dataForm.category_global_form_id,
        },
        {
          name: ['form', 'is_agree'],
          value: dataForm.is_agree,
        },
        {
          name: ['form', 'is_checkin_form'],
          value: dataForm.is_checkin_form,
        },
        {
          name: ['form', 'purpose'],
          value: dataForm.purpose || undefined,
        },
        {
          name: ['form', 'induction_validity_months'],
          value: dataForm.induction_validity_months || undefined,
        },
        {
          name: ['form', 'embed_induction'],
          value: dataForm.embed_induction ? 1 : 0,
        },
        {
          name: ['form', 'embed_induction_form_id'],
          value: dataForm.embed_induction_form_id || undefined,
        },
        {
          name: ['form', 'embed_induction_mode'],
          value: dataForm.embed_induction_mode || undefined,
        },
        {
          name: ['form', 'embed_induction_required'],
          value: dataForm.embed_induction_required ? 1 : 0,
        },
        {
          name: ['form', 'embed_induction_confirm'],
          // Defaults ON, including for forms saved before this existed, where
          // the field comes back undefined.
          value: dataForm.embed_induction_confirm === false ? 0 : 1,
        },
        {
          name: ['form', 'safety_document_type'],
          value: dataForm.safety_document_type || undefined,
        },
        {
          name: ['form', 'global_form_id'],
          value: dataForm.global_form_id || undefined,
        },
        {
          name: ['form', 'is_primary'],
          value: dataForm.is_primary ? true : false,
        },
        {
          name: ['form', 'meta_data', 'visitor_types'],
          value: dataForm.meta_data?.visitor_types,
        },
        {
          name: ['form', 'meta_data', 'is_hosts_enabled'],
          value: dataForm.meta_data?.is_hosts_enabled,
        },
        {
          name: ['form', 'meta_data', 'required_visitor_types_for_hosts'],
          value: dataForm.meta_data?.required_visitor_types_for_hosts,
        },
        {
          name: ['form', 'meta_data', 'allow_hosts'],
          value: dataForm.meta_data?.allow_hosts,
        },
        {
          name: ['form', 'meta_data', 'departments'],
          value: dataForm.meta_data?.departments,
        }
      ];

      if (dataForm.category_global_form_id) {
        fieldList.push(
          {
            name: ['form', 'type'],
            value: dataForm.type + '-' + dataForm.category_global_form_id || '',
          }
        )

        getFormData(dataForm.category_global_form_id)
      } else {
        fieldList.push(
          {
            name: ['form', 'type'],
            value: dataForm.type || '',
          }
        )
      }

      setFields(fieldList);
        
      if(dataForm.is_public == 1) setIsShowQr(true)
      if(dataForm.is_public == 0) setIsShowQr(false)

      setUserChecked(dataForm.is_share_all);
      setUserInviteList(dataForm.viewable_users ? dataForm.viewable_users.map(id => parseInt(id, 10)) : []);


    }
    getLivedForms()
  }, [props.propertyId, props.visibleFormModal, dataForm]);

  const handleSubmit = (e) => {
    // setLoading(true);

    form
      .validateFields()
      .then(values => {
        // console.log('values',values);
        setModalLoading(true);
        onStore(values);
      })
      .catch(info => {
        console.log('Validate Failed:', info);
        // setLoading(false);
      });
  }

  const onStore = (values) => {
    let users_invited = [];

    // Legacy form (no library category): keep its original type + check-in flag
    // untouched — it stays on the old survey engine. NEW forms derive the type +
    // check-in flag from the selected library Category ("Check-In" ⇒ checkin_form).
    let isCheckin;
    if (isLegacyForm) {
      values.form.type = dataForm.type;
      isCheckin = !!values.form.is_checkin_form;
    } else {
      const selectedCategory = formCategories.find((c) => c.id === values.form.category_global_form_id);
      isCheckin = selectedCategory ? isCheckinCategory(selectedCategory.name) : false;
      values.form.type = isCheckin ? 'checkin_form' : 'self_create';
    }

    const data = {
      form: {
        ...values.form,
        date: values.form.date ? dateHelper.dateForAPI(values.form.date) : '',
        property_id: props.propertyId,
        file_id: fileId,
        is_public: values.form.is_public && values.form.is_public == true ? 1 : 0,
        is_share_all: values.form.is_share_all ? 1 : 0,
        is_primary: values.form.is_primary ? 1 : 0,
        // Library template (global_form_id): the backend copies its
        // schema_json (isolated). If the author customized it via the builder, send
        // the edited schema_json — the backend keeps that instead of the template copy.
        // Bake host defaults so an unconfigured List Hosts field shows all hosts.
        global_form_id: values.form.global_form_id || null,
        ...(editedSchema ? { schema_json: bakeHostDefaults(editedSchema.schema_json, propertyHosts) } : {}),
        is_checkin_form: isCheckin ? 1 : (values.form.is_checkin_form ? 1 : 0),
        user_invited: userInviteList,
        survey: surveyDataSubmit,
        signature_path: padRef.current && Object.keys(padRef.current).length === 0 && padRef.current.constructor === Object ? '' : padRef.current.toDataURL('image/png'),
        meta_data: {
          ...values.form.meta_data,
          allow_hosts: dataForm.meta_data?.allow_hosts || [],
          departments: dataForm.meta_data?.departments || []
        }
      }
    }

    formService.storeOrUpdate(data, dataForm.id).then(res => {
      if(res.code === '0000'){
        form.resetFields();
        cancelModal();

        if(!props.fromProperty){
          props.updateFormData();
        }
        // When embedded in another screen (e.g. the asset Form tab), surface the
        // freshly created form so the parent can act on it (e.g. attach it to the
        // asset). Guarded + create-only, so the standalone Form page is unaffected.
        if (!dataForm.id && typeof props.onCreated === "function" && res.form) {
          props.onCreated(res.form);
        }
        setSurveyDataSubmit({});
        setLoading(false);
      }else{
        setLoading(false);
      }
    });
  }

  const uploadProps = {
    name: "Image[file]",
    action: apiEndpoint.images,
    headers: authHeader(true),
    beforeUpload: (file, fileList) => {
      if (file.type !== 'application/pdf') {
        message.error(`${file.name} is not a pdf file`);
        return false;
      }    

      let $oldOne = $('.anticon-delete')[0];
      
      setTimeout(()=>{
        if($oldOne)
          $($oldOne).trigger('click');
      },100);
    },
    onChange: (response) => {
      if(response.file && response.file.status == "done"){
        setFileId(response.file.response.image.id);
      }
    },    
    listType: "text",
    multiple: false
  }

  const onChangeCheckBox = e => {
    setUserChecked(e.target.checked);

    if(e.target.checked)
    {
      let result = [];

      _.forEach(userProperty, (user, index) => {
        result.push(user.value);
      });

      setUserInviteList(result);
    }
  }

  const onUserListChange = checkedValues => {
    setUserInviteList(checkedValues);
  }

  const submitSurveyData = (survey) => {
    setSurveyDataSubmit(survey.data);
  }

  const showViewSurveyResult = (item) => {
    setSurveyResult(item);
    setVisibleViewSurveyResult(true);
  }

  const cancelViewSurveyResult = () => {
    setSurveyResult({});
    setVisibleViewSurveyResult(false);
  }

  // Phase 07 — group submissions so a REGISTERED user's multiple submissions collapse
  // into one row (View Result then lists all their submitted times). Visitors /
  // anonymous submissions (no user_id) can't be tied together, so each stays its own
  // row. Rows and each user's submissions are ordered newest-first.
  const groupedSchemaSubmissions = useMemo(() => {
    const time = (s) => (s.submitted_at ? new Date(s.submitted_at).getTime() : 0);
    const byUser = new Map();
    const singles = [];
    (schemaSubmissions || []).forEach((s) => {
      if (s.user_id) {
        const key = `u${s.user_id}`;
        if (!byUser.has(key)) {
          byUser.set(key, []);
        }
        byUser.get(key).push(s);
      } else {
        singles.push(s);
      }
    });
    const rows = [];
    byUser.forEach((subs, key) => {
      const sorted = [...subs].sort((a, b) => time(b) - time(a));
      rows.push({
        key,
        submitter_name: sorted[0].submitter_name,
        submitter_type: sorted[0].submitter_type,
        submitted_at: sorted[0].submitted_at,
        count: sorted.length,
        // True when ANY submission in the group came from an induction run.
        has_induction: sorted.some((x) => x.is_induction),
        // Every channel this person used, not just the latest — somebody who
        // reports from the paddock and again from the office did both, and a
        // row showing only the most recent would misdescribe the older one.
        sources: [...new Set(sorted.map((x) => x.source).filter(Boolean))],
        submissions: sorted,
      });
    });
    singles.forEach((s) => {
      rows.push({
        key: `s${s.id}`,
        submitter_name: s.submitter_name,
        submitter_type: s.submitter_type,
        submitted_at: s.submitted_at,
        count: 1,
        has_induction: !!s.is_induction,
        sources: s.source ? [s.source] : [],
        submissions: [s],
      });
    });
    return rows.sort((a, b) => time(b) - time(a));
  }, [schemaSubmissions]);

  // Phase 07 — open the View Result modal for a submitter's submission(s).
  // ViewSurveyResultModal renders schema answers from `global_form_submission`
  // (an array — one entry per submission, each stamped with its time).
  const showSchemaSubmission = (record) => {
    setSurveyResult({
      form: dataForm,
      user: record.submitter_name,
      agree_date: record.submitted_at,
      // Check-in details of the represented check-in (newest submission in the
      // group), so ViewSurveyResultModal can show the Check-in details section
      // here too. null when the submissions aren't tied to a check-in.
      checkin_info: (record.submissions
        && record.submissions[0]
        && record.submissions[0].checkin_info) || null,
      // record.submissions is newest-first; list the collapse oldest-first so the
      // panels read chronologically (the top header stays the latest submission).
      global_form_submission: [...(record.submissions || [])]
        .reverse()
        .map((s) => ({
          ...(s.answers || {}),
          submisison_date: s.submitted_at,
          // Snapshot of the form as it was when THIS submission was made (null for
          // pre-versioning rows) — so old submissions render their own field set.
          _schema: s.schema_json || null,
        })),
    });
    setVisibleViewSurveyResult(true);
  };

  // Mirrors FormSubmission::SOURCE_LABELS on the backend. Kept in step by hand
  // because it is three strings; if a fourth channel ever appears, an unknown
  // value falls through to itself rather than rendering blank.
  const SOURCE_LABELS = {
    web: 'Web',
    whatsapp: 'WhatsApp',
    mobile: 'Mobile app',
  };

  const schemaSubmissionColumns = [
    {
      title: 'Submitted by',
      dataIndex: 'submitter_name',
      key: 'submitter_name',
      render: (value) => value || 'Anonymous',
    },
    {
      title: 'Type',
      dataIndex: 'submitter_type',
      key: 'submitter_type',
      width: 190,
      // A form can be run BOTH as a check-in and as an induction, and the two
      // are otherwise identical rows — same person, same channel. Without this
      // the Submissions tab cannot answer "did they actually do the induction?"
      render: (value, record) => (
        <>
          {value || '-'}
          {record.has_induction && (
            <Tag color="green" style={{ marginLeft: 6 }}>
              Induction
            </Tag>
          )}
        </>
      ),
    },
    {
      title: 'Submissions',
      dataIndex: 'count',
      key: 'count',
      width: 110,
      render: (value) => value || 1,
    },
    {
      title: 'Via',
      dataIndex: 'sources',
      key: 'sources',
      width: 130,
      // BLANK, not "Web", when the channel is unknown. Submissions that predate
      // the column genuinely do not record where they came from, and most of
      // them being web is exactly what would make that guess convincing and
      // wrong.
      render: (sources) =>
        sources && sources.length
          ? sources.map((source) => (
              <Tag key={source} color={source === 'whatsapp' ? 'green' : 'default'}>
                {SOURCE_LABELS[source] || source}
              </Tag>
            ))
          : <span style={{ color: '#bbb' }}>—</span>,
    },
    {
      title: 'Last submitted',
      dataIndex: 'submitted_at',
      key: 'submitted_at',
      width: 170,
      render: (value) => (value ? moment(value).format('DD/MM/YYYY HH:mm') : '-'),
    },
    {
      title: '',
      key: 'action',
      width: 120,
      render: (_, record) => (
        <Button
          size="small"
          type="primary"
          className="btn-success"
          onClick={() => showSchemaSubmission(record)}
        >
          View Result
        </Button>
      ),
    },
  ];

  const handleClear = () => {
    padRef.current.clear();
  }

  const renderOptionsSurveyQuestion = (questionIndex) => {
    let options = [];
    _.forEach(surveyQuestionTypes, (type, index) => {
      options.push(
        <Option key={index} value={type.value}>
            <div>{type.label}</div>
        </Option>
      );
    })
    return (
      <Select
        placeholder="Select a question type"
        allowClear
        size="large"
        onChange={(value) => onChangeSurveyQuestionType(value, questionIndex)}
      >
        {options}
      </Select>
    );
  }

  const onChangeSurveyQuestionType = (value, questionIndex) => {
    const updatedSurveyTypes = [...surveyQuestionType];
    updatedSurveyTypes[questionIndex] = value;
    setSurveyQuestionType(updatedSurveyTypes);
  };

  const changeFormMode = (value) => {
    setIsShowQr(value);
  }

  const showPreviewModal = () => {
    setIsVisiblePreviewModal(true);
  }

  const cancelPreviewModal = () => {
    setIsVisiblePreviewModal(false);
  }
  const getDataSource = () => {
    return userFormList.concat(visitorFormList)
  } 

  const handleMenuClick = (userForm, e) => {
    if (e.key === 'viewResult') {
      showViewSurveyResult(userForm);
    }
    if (e.key === 'viewVisitor') {
      setVisitor(userForm.visitor_info)
      setVisibleVisitorModal(true);
    }
    if (e.key === 'viewProfile') {
      setVisibleCheckinUserProfileModal(true)
      setCheckinUserId(userForm.user_id);
    }
    if (e.key === "requestShareProfile") {
      profileService
        .requestShareProfile(userForm.form_id, userForm.user_id)
        .then((res) => {
          // Guard: the service resolves to undefined on a non-200 response.
          if (res && res.code === "0000") {
            message.success(res.message);
          } else if (res && res.message) {
            message.error(res.message);
          }
        });
    }
  }
  const menu = (userForm) => (
    <Menu onClick={handleMenuClick.bind(this, userForm)}>
      {(userForm.is_investigated || userForm.visitor_id) &&
        [
          "self_create", 
          "system_forms", 
          "bio_form", 
          "checkin_form", 
          "hazard_form", 
          "training_form", 
          "illness_form",
          "near_miss_form"
        ]?.includes(userForm.form.type) &&
        (
          <Menu.Item key="viewResult" icon={<EditOutlined />}>
            <IntlMessages id="formPage.modal.table.action.viewResult" />
          </Menu.Item>
        )}
      {userForm.visitor_info && (
        <Menu.Item key="viewVisitor" icon={<UserOutlined />}>
          <IntlMessages id="formPage.modal.table.action.viewVisitor" />
        </Menu.Item>
      )}
      {(userForm.user_info && userForm.user_info.share_with_property_owner) ? (
        <Menu.Item key="viewProfile" icon={<UserOutlined />}>
          <IntlMessages id="formPage.modal.table.action.viewProfile" />
        </Menu.Item>
      ) : <></>}
      {userForm.user_info && !userForm.user_info.share_with_property_owner ? (
        <Menu.Item key="requestShareProfile" icon={<SendOutlined />}>
          <IntlMessages id="formPage.modal.table.action.requestToSeeProfile" />
        </Menu.Item>
      ) : <></>}
    </Menu>
  );

  const columns = [
    {
      label: <IntlMessages id="formPage.modal.table.name" />,
      minWidth: 100,
      sortable: false,
      position: 1,
      priorityLevel: 1,
      CustomComponent: (cell) => {
        let row = cell.row;
        return (
          <Col>
            <b>{row.user ? row.user : row.visitor}</b> -
            <i>
              [
              {(row.is_investigated || row.visitor_id) &&
              row.form.type === "self_create"
                ? "Completed the survey"
                : "Agreed"}{" "}
              at {row.user ? row.agree_date : row.created_at}]
            </i>
          </Col>
        );
      },
    },
    {
      label: <IntlMessages id="formPage.modal.table.type" />,
      sortable: false,
      position: 2,
      priorityLevel: 2,
      CustomComponent: (cell) => {
        let row = cell.row;
        return row.visitor ? 'Visitor' : 'Registered User'
      },
    },
    {
      label: <IntlMessages id="formPage.modal.table.signature" />,
      sortable: false,
      position: 3,
      priorityLevel: 3,
      CustomComponent: (cell) => {
        let row = cell.row;
        if (row.signature_path) {
          return (
            <>
              <p>Signed</p>
              <img
                className="signature-image"
                src={process.env.REACT_APP_API_BASE_URL + row.signature_path}
              />
            </>
          );
        }
        return <></>
      },
    },
    {
      label: <IntlMessages id="formPage.modal.table.action" />,
      sortable: false,
      position: 4,
      priorityLevel: 4,
      CustomComponent: (cell) => {
        let row = cell.row;
        return (
          <Dropdown overlay={menu(row)} trigger={["click"]}>
            <Button className="btn-success ant-btn-primary margin-right-0 margin-bottom-5">
              <IntlMessages id="antTable.title.actions" /> <DownOutlined />
            </Button>
          </Dropdown>
        );
      },
    },
  ];

  const canceVisitorlModal = () => {
    setVisibleVisitorModal(false);
    setVisitor({});
  };

  const cancelCheckinUserProfileModal = () => {
    setVisibleCheckinUserProfileModal(false)
    setCheckinUserId(null)
  }

  const renderPreviewForm = (formType) => {
    let template = <></>;
    switch(formType){
      case 'bio_form':
        template = BioForm
        break
      case 'checkin_form':
        template = CheckinForm
        break
      case 'hazard_form':
        template = HazardForm
        break
      case 'training_form':
        template = TrainingForm
        break
      case 'illness_form':
        template = IllnessForm
        break
      case 'near_miss_form':
        template = NearMissForm
        break  
      default:
        template = <></>
        break
    }
    return (
      <Row>
        <Col className="btn-view-form">
          <Button className="action-button btn-view-bio-form" onClick={showPreviewModal}>View Form</Button>
        </Col>
        <PreviewFormTemplate
          isVisiblePreviewModal={isVisiblePreviewModal}
          cancelPreviewModal={cancelPreviewModal}
          type={formType}
          template={template}
          propertyId={activePropertyId}
        />
      </Row>
    )
  }
  const renderOptionVisitorTypes = () => (
    <Select
      mode="multiple"
      placeholder="Select a visitor type"
      allowClear
      onChange={onVisitorTypeChange}
      size="large"
    >
      {visitorTypes.map((type, index) => (
        <Option key={index} value={type.value}>
          <div>{type.label}</div>
        </Option>
      ))}
    </Select>
  );

  const onVisitorTypeChange = (selectedValues = []) => {
    const selectedTypes = visitorTypes.filter((type) =>
      selectedValues.includes(type.value)
    );
    setSelectedVisitorTypes(selectedTypes);
  };

  const renderVisibilityOptions = useCallback( (questionIndex) => {
    const selectedVisibility = visibility[questionIndex] || [];
    return (
      <Select
        placeholder="Select Visibility"
        allowClear
        mode="multiple"
        value={selectedVisibility}
        onChange={(value) => onVisibilityChange(value, questionIndex)}
        size="large"
      >
        {selectedVisitorTypes.map((type, index) => (
          <Option key={index} value={type.value}>
            <div>{type.label}</div>
          </Option>
        ))}
      </Select>
    );
  },[visibility, selectedVisitorTypes]);

  const renderOptionVisitorTypesForHosts = useCallback(() => {
    return (
      <Select
        mode="multiple"
        placeholder="Select a visitor type"
        allowClear
        size="large"
      >
        {selectedVisitorTypes.map((type, index) => (
          <Option key={index} value={type.value}>
            <div>{type.label}</div>
          </Option>
        ))}
      </Select>
    )
  }, [selectedVisitorTypes]);

  const onVisibilityChange = (value, questionIndex) => {
    const updatedVisibility = [...visibility];
    updatedVisibility[questionIndex] = value;
    setVisibility(updatedVisibility);
  };

  const handleRemove = (remove, questionIndex) => {
    setSurveyQuestionType((prevTypes) => {
      const updatedTypes = [...prevTypes];
      updatedTypes.splice(questionIndex, 1); 
      return updatedTypes;
    });
    setVisibility((prevVisibilities) => {
      const updatedVisibilities = [...prevVisibilities];
      updatedVisibilities.splice(questionIndex, 1);
      return updatedVisibilities;
    });
    remove(questionIndex);
  };

  const renderRuleYesNo = () => {
    return (
      <Select
        showSearch
        placeholder="Select"
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        options={[
          { value: 'either', label: 'Either answer is valid' },
          { value: 'no', label: 'Visitor must answer "No"' },
          { value: 'yes', label: 'Visitor must answer "Yes"' },
        ]}
      />
    )
  };

  const renderResponseConditionsFields = (name, fieldKey, restField) => {
    return (
      <>
        <Form.Item
          {...restField}
          name={[name, 'meta_data', 'response_required']}
          fieldKey={[fieldKey, 'meta_data', 'response_required']}
          valuePropName="checked"
        >
          <Checkbox>{<IntlMessages id="formPage.modal.responseRequired" />}</Checkbox>
        </Form.Item>

        <Form.Item
          {...restField}
          name={[name, 'meta_data', 'prefill_response']}
          fieldKey={[fieldKey, 'meta_data', 'prefill_response']}
          valuePropName="checked"
        >
          <Checkbox>{<IntlMessages id="formPage.modal.prefillResponse" />}</Checkbox>
        </Form.Item>
      </>
    )
  };

  const uploadImgProps = {
    name: "Image[file]",
    action: apiEndpoint.images,
    headers: authHeader(true),
    beforeUpload: (file, fileList) => {
      //
    },
    onChange: (response,) => {
      //
    },
    listType: "picture",
    multiple: false,
  };

  const renderQuestionFields = (questionType, name, fieldKey, restField) => {
    switch (questionType) {
      case 'yes/no':
        return (
         <>
          <Form.Item
            {...restField}
            name={[name, 'meta_data', 'rule']}
            fieldKey={[fieldKey, 'meta_data', 'rule']}
            rules={[{ required: true, message: 'This field is required' }]}
          >
            {renderRuleYesNo()}
          </Form.Item>
         </>
        );
      case 'multi_selection':
      case 'multiple_choice':
        return (
          <Form.Item
            {...restField}
            name={[name, 'meta_data', 'options']}
            fieldKey={[fieldKey, 'meta_data', 'options']}
            rules={[{ required: true, message: 'This field is required' }]}
          >
            <Select
              mode="tags"
              style={{
                width: '100%',
              }}
              placeholder="Enter options"
            />
          </Form.Item>
        );
      case 'fixed_text':
        return (
          <Form.Item
            {...restField}
            name={[name, 'meta_data', 'text']}
            fieldKey={[fieldKey, 'meta_data', 'text']}
            rules={[{ required: true, message: 'This field is required' }]}
          >
            <Input.TextArea autoSize rows={4} placeholder="Enter text" />           
          </Form.Item>
        )
      case 'fixed_image':
        return (
          <Form.Item
            {...restField}
            label="Image"
            name={[name, 'meta_data', "image_id"]}
            fieldKey={[fieldKey, 'meta_data', "image_id"]}
            getValueFromEvent={(e) => e.file.response?.image.id}
            rules={[
              {
                required: true,
                message:
                  "This field is required",
              },
            ]}
          >
            <Upload {...uploadImgProps} >
              <Button
                className="action-button"
                icon={<UploadOutlined />}
              >
                Upload
              </Button>
            </Upload>
          </Form.Item>
        );
      case 'signature':
      case 'number':
      case 'text':
      default:
        return <></>;
    }
  };

  const renderFormTemplate = (formType) => {
    switch(formType){
      case 'self_create':
        return !dataForm.is_investigated ? (
          <>
            <Form.Item
              name={['form', 'survey']}
              className="isoInputWrapper"
            >
              <Survey.Survey json={surveyContent} onComplete={submitSurveyData}/>
            </Form.Item>
            <hr/>
          </>
        ) : (<></>)
      case 'pdf_upload':
        return (
          <>
            <Form.Item
              name={['form', 'is_agree']}
              className="isoInputWrapper"
              valuePropName="checked"
            >
              <Checkbox>{<IntlMessages id="formPage.modal.agreeConfirm" />}</Checkbox>
              
            </Form.Item>
            <h3>{dataForm.signature_path ? <IntlMessages id="formPage.modal.savedSignature" /> : <IntlMessages id="formPage.modal.signature" />}</h3>
            {
              dataForm.signature_path ? <img src={process.env.REACT_APP_API_BASE_URL + dataForm.signature_path} /> :     
              <div className="signature-area">
                <SignatureCanvas ref={padRef} />
                <button onClick={handleClear} className="signature-clear-button">Clear</button>
              </div>
            }
          </>
        )
      case 'system_forms':
        return !showFinalScreen ? (
          <Form.Item
          name={['form', 'global_form']}
          className="isoInputWrapper"
          >
            <GlobalForm formData={dataForm} setShowFinalScreen={setShowFinalScreen} visibleFormModal={props.visibleFormModal}/>
          </Form.Item>
        ) : <></>
      case 'bio_form':
        return !showFinalScreen ? (
          <BioForm formData={dataForm} setShowFinalScreen={setShowFinalScreen} isAbleToSubmit={true}/>
        ) : <></>
      case 'hazard_form':
        return !showFinalScreen ? (
          <HazardForm propertyId={activePropertyId} formData={dataForm} setShowFinalScreen={setShowFinalScreen} isAbleToSubmit={true}/>
        ) : <></>
      case 'training_form':
        return !showFinalScreen ? (
          <TrainingForm propertyId={activePropertyId} formData={dataForm} setShowFinalScreen={setShowFinalScreen} isAbleToSubmit={true}/>
        ) : <></>
      case 'illness_form':
        return !showFinalScreen ? (
          <IllnessForm propertyId={activePropertyId} formData={dataForm} setShowFinalScreen={setShowFinalScreen} isAbleToSubmit={true}/>
        ) : <></>
      case 'near_miss_form':
        return !showFinalScreen ? (
          <NearMissForm propertyId={activePropertyId} formData={dataForm} setShowFinalScreen={setShowFinalScreen} isAbleToSubmit={true}/>
        ) : <></>
      default:
        return <></>
    }
  }

  return (
    <FormModalWrapper
      className="user-access-modal"
      forceRender={true}
      maskClosable={false}
      visible={props.visibleFormModal}
      title={!dataForm.id ? <IntlMessages id="formPage.modal.addForm" /> : <IntlMessages id="formPage.modal.editForm" />}
      onCancel={cancelModal}
      footer={[
        <Button key="back" onClick={cancelModal} className="cancel-button">
          {<IntlMessages id="propertyPage.modal.cancel" />}
        </Button>,
        (dataForm.is_public == 1 || currentUser.id == dataForm.user_id || !dataForm.id) && <Button key="submit" className="btn-success" type="primary" loading={loading} onClick={handleSubmit}>
          {<IntlMessages id="propertyPage.modal.save" />}
        </Button>,
      ]}
    >
      <Form
        form={form}
        layout="vertical"
        scrollToFirstError
        fields={fields}
        className="form-body"
      >
        <Row>
          <Col xs={{span: 24}} md={{span: currentUser.id == dataForm.user_id || !dataForm.id ? 14 : 24}}>
            <Form.Item
              name={['form', 'is_public']}
              className="isoInputWrapper"
              style={{float: "right"}}
              valuePropName="checked"
            >
              <Switch checkedChildren="Public" unCheckedChildren="Private" onChange={changeFormMode}
              disabled={(dataForm.is_public == 1 || currentUser.id == dataForm.user_id || !dataForm.id) ? false : true}/>
            </Form.Item>
            <br/>
            <br/>
            <hr/>
            <br/>
            <p>{<IntlMessages id="formPage.modal.instruction" />}</p>
            <br/>
            <Row>
              <Col xs={{span: 24}} md={{span: 11}}>
                <Form.Item
                  name={['form', 'name']}
                  className="isoInputWrapper"
                  label={<IntlMessages id="formPage.modal.formName" />}
                  rules={[
                    {
                      required: true,
                      message: 'This field is required',
                    },
                  ]}
                >
                 <Input size="large" placeholder="Input form name" 
                 disabled={(dataForm.is_public == 1 || currentUser.id == dataForm.user_id || !dataForm.id) ? false : true}/>
                </Form.Item>
              </Col>
              <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                <Form.Item
                  name={['form', 'date']}
                  className="isoInputWrapper"
                  label={<IntlMessages id="Creation Date" />}
                  rules={[
                    {
                      required: true,
                      message: 'This field is required',
                    },
                  ]}
                >
                     <DatePicker size="large" style={{ width: '100%' }} format={dateFormat}
                  disabled={(dataForm.is_public == 1 || currentUser.id == dataForm.user_id || !dataForm.id) ? false : true} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xs={{ span: 24 }} md={{ span: 24 }}>
                <Form.Item
                  name={["form", "safety_document_type"]}
                  className="isoInputWrapper"
                  label="Safety Documents category (optional)"
                >
                  <Select
                    size="large"
                    allowClear
                    placeholder="Not filed — leave blank to skip"
                    options={safetyDocTags.map((t) => ({
                      value: t.value,
                      label: t.label,
                    }))}
                  />
                </Form.Item>
              </Col>
            </Row>
            {!isLegacyForm ? (
            <>
            <Row>
              <Col xs={{span: 24}} md={{span: 11}}>
                <Form.Item
                  name={['form', 'category_global_form_id']}
                  className="isoInputWrapper"
                  label={<IntlMessages id="Form Category" />}
                  rules={[
                    {
                      required: true,
                      message: 'This field is required',
                    },
                  ]}
                >
                  {renderOptionsFormType()}
                </Form.Item>
              </Col>
              <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                <Form.Item
                  name={['form', 'global_form_id']}
                  className="isoInputWrapper"
                  label={<IntlMessages id="Form Template" />}
                  rules={[
                    {
                      required: true,
                      message: 'Please select a form from the library',
                    },
                  ]}
                >
                  <LibraryTemplatePickerControl
                    disabled={!!dataForm.id}
                    templates={schemaTemplates}
                    editedSchema={editedSchema}
                    onOpenPicker={() => setLibraryPickerVisible(true)}
                    onPreview={() => setSchemaPreview({
                      visible: true,
                      form: editedSchema
                        ? { name: editedSchema.name, schema_json: editedSchema.schema_json }
                        : null,
                    })}
                    onEdit={() => setBuilderVisible(true)}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xs={{span: 24}} md={{span: 11}}>
                <Form.Item
                  name={['form', 'purpose']}
                  className="isoInputWrapper"
                  label={<IntlMessages id="Form Purpose" />}
                  initialValue="other"
                  rules={[
                    {
                      required: true,
                      message: 'This field is required',
                    },
                  ]}
                >
                  <Select
                    size="large"
                    showSearch
                    optionFilterProp="label"
                    placeholder="Select a form purpose"
                    options={FORM_PURPOSES.map((p) => ({ value: p.value, label: p.label }))}
                    disabled={(dataForm.is_public == 1 || currentUser.id == dataForm.user_id || !dataForm.id) ? false : true}
                  />
                </Form.Item>
              </Col>
              {/* How long an induction run against this form stays valid. Only
                  meaningful for induction purposes, so it appears with them. */}
              <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                <Form.Item noStyle shouldUpdate>
                  {() => (
                    isInductionPurpose(form.getFieldValue(['form', 'purpose'])) ? (
                      <Form.Item
                        name={['form', 'induction_validity_months']}
                        className="isoInputWrapper"
                        label={<IntlMessages id="Induction validity (months)" />}
                        extra="Leave blank — never expires"
                      >
                        <InputNumber
                          size="large"
                          min={1}
                          style={{ width: '100%' }}
                          placeholder="e.g. 12"
                          disabled={(dataForm.is_public == 1 || currentUser.id == dataForm.user_id || !dataForm.id) ? false : true}
                        />
                      </Form.Item>
                    ) : null
                  )}
                </Form.Item>
              </Col>
            </Row>

            {/* Embedded induction — only a CHECK-IN form can carry one. An
                induction form is the thing being carried, not the carrier. */}
            <Form.Item noStyle shouldUpdate>
              {() => {
                const isCheckin = !!form.getFieldValue(['form', 'is_checkin_form']);
                if (!isCheckin) {
                  return null;
                }
                const embedOn = Number(form.getFieldValue(['form', 'embed_induction'])) === 1;
                const mode = form.getFieldValue(['form', 'embed_induction_mode']);
                const editable = (dataForm.is_public == 1 || currentUser.id == dataForm.user_id || !dataForm.id);

                return (
                  <>
                    <Row>
                      <Col xs={{ span: 24 }} md={{ span: 11 }}>
                        <Form.Item
                          name={['form', 'embed_induction']}
                          className="isoInputWrapper"
                          label={<IntlMessages id="Embed Induction?" />}
                          initialValue={0}
                          extra="Run an induction as part of this check-in"
                        >
                          <Radio.Group size="large" disabled={!editable}>
                            <Radio.Button value={0}>No</Radio.Button>
                            <Radio.Button value={1}>Yes</Radio.Button>
                          </Radio.Group>
                        </Form.Item>
                      </Col>
                      {embedOn && (
                        <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                          <Form.Item
                            name={['form', 'embed_induction_form_id']}
                            className="isoInputWrapper"
                            label={<IntlMessages id="Induction form" />}
                            rules={[{ required: true, message: 'Choose which induction to run' }]}
                          >
                            <Select
                              size="large"
                              showSearch
                              allowClear
                              optionFilterProp="label"
                              loading={loadingInductionForms}
                              placeholder="Select an induction"
                              disabled={!editable}
                              notFoundContent={
                                loadingInductionForms
                                  ? null
                                  : 'No induction forms on this property. Create one in Forms and set its purpose to an induction type.'
                              }
                              options={inductionForms.map((f) => ({
                                value: f.id,
                                label: f.name,
                              }))}
                            />
                          </Form.Item>
                        </Col>
                      )}
                    </Row>

                    {embedOn && (
                      <Row>
                        <Col xs={{ span: 24 }} md={{ span: 11 }}>
                          <Form.Item
                            name={['form', 'embed_induction_mode']}
                            className="isoInputWrapper"
                            label={<IntlMessages id="How should it run?" />}
                            rules={[{ required: true, message: 'Choose how the induction should run' }]}
                          >
                            <Select
                              size="large"
                              disabled={!editable}
                              placeholder="Select"
                              options={[
                                { value: 'chain', label: 'Chain after check-in' },
                                { value: 'send_link', label: 'Auto-send the link' },
                              ]}
                            />
                          </Form.Item>
                        </Col>
                        {mode === 'chain' && (
                          <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                            <Form.Item
                              name={['form', 'embed_induction_required']}
                              className="isoInputWrapper"
                              label={<IntlMessages id="Completion" />}
                              initialValue={0}
                            >
                              <Select
                                size="large"
                                disabled={!editable}
                                options={[
                                  { value: 0, label: 'Optional — check-in proceeds, induction stays Pending' },
                                  { value: 1, label: 'Required — check-in is not recorded until it is done' },
                                ]}
                              />
                            </Form.Item>
                          </Col>
                        )}
                      </Row>
                    )}

                    {mode === 'chain' && (
                      <Row>
                        <Col xs={{ span: 24 }} md={{ span: 11 }}>
                          <Form.Item
                            name={['form', 'embed_induction_confirm']}
                            className="isoInputWrapper"
                            label={<IntlMessages id="Ask if already inducted?" />}
                            initialValue={1}
                            extra="Asks first, and only shows the induction if we can't find one for them."
                          >
                            <Select
                              size="large"
                              disabled={!editable}
                              options={[
                                { value: 1, label: 'Yes — ask before showing the induction' },
                                { value: 0, label: 'No — always show the induction' },
                              ]}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    )}

                    {/* Say the consequence where the choice is made. Discovering
                        it later means discovering it through a visitor who never
                        appeared as checked in. */}
                    {embedOn && mode === 'chain'
                      && Number(form.getFieldValue(['form', 'embed_induction_required'])) === 1 && (
                      <Row>
                        <Col xs={{ span: 24 }}>
                          <Alert
                            type="warning"
                            showIcon
                            style={{ marginBottom: 16 }}
                            message="If they don't finish the induction, nothing is recorded — they won't appear as checked in."
                          />
                        </Col>
                      </Row>
                    )}
                  </>
                );
              }}
            </Form.Item>

            <Row>
              <Col xs={{span: 24}}>
                <Form.Item noStyle shouldUpdate>
                  {() => {
                    const purpose = form.getFieldValue(['form', 'purpose']);
                    const categoryId = form.getFieldValue(['form', 'category_global_form_id']);
                    const selectedCategory = formCategories.find((c) => c.id === categoryId);
                    const formIsCheckin = selectedCategory
                      ? isCheckinCategory(selectedCategory.name)
                      : !!form.getFieldValue(['form', 'is_checkin_form']);
                    const isContractorPrimary = purpose === 'contractor_check_in';
                    return (
                      <Form.Item
                        name={['form', 'is_primary']}
                        className="isoInputWrapper"
                        valuePropName="checked"
                      >
                        <Checkbox
                          disabled={(dataForm.is_public == 1 || currentUser.id == dataForm.user_id || !dataForm.id) ? false : true}
                        >
                          Set as Primary
                        </Checkbox>
                      </Form.Item>
                    );
                  }}
                </Form.Item>
              </Col>
            </Row>
            </>
            ) : (
            <Row>
              <Col xs={{span: 24}} md={{span: 11}}>
                <Form.Item
                  name={['form', 'type']}
                  className="isoInputWrapper"
                  label={<IntlMessages id="formPage.modal.formType" />}
                >
                  <Select size="large" disabled options={formTypes.map((t) => ({ value: t.value, label: t.label }))} />
                </Form.Item>
              </Col>
              <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                <Form.Item noStyle shouldUpdate={(prevValues) => prevValues['form']}>
                  {({ getFieldValue }) => {
                    const f = getFieldValue('form');
                    if (!f) { return null; }
                    if (f.type === 'pdf_upload') {
                      return (
                        <>
                          <Form.Item name={['attachment']} label="Attachment">
                            <Upload {...uploadProps}>
                              <Button className="action-button" icon={<UploadOutlined />}
                                disabled={(dataForm.is_public == 1 || currentUser.id == dataForm.user_id || !dataForm.id) ? false : true}>Upload PDF file</Button>
                            </Upload>
                          </Form.Item>
                          {dataForm.files && dataForm.files.length > 0 && (
                            <a target="_blank" rel="noopener noreferrer" href={process.env.REACT_APP_API_BASE_URL + dataForm.files[dataForm.files.length - 1].path}>
                              {process.env.REACT_APP_API_BASE_URL + dataForm.files[dataForm.files.length - 1].path}
                            </a>
                          )}
                        </>
                      );
                    }
                    if ((f.type || '').includes('system_forms')) {
                      return (
                        <Row>
                          <Col className="btn-view-form">
                            <Button className="action-button btn-view-bio-form" onClick={showPreviewModal}>View Form</Button>
                          </Col>
                          <PreviewFormModal isVisiblePreviewModal={isVisiblePreviewModal} cancelPreviewModal={cancelPreviewModal}
                            globalForm={globalForm} readOnly={true} categoryGlobalForm={categoryGlobalForm} />
                        </Row>
                      );
                    }
                    if (['bio_form', 'checkin_form', 'hazard_form', 'training_form', 'illness_form', 'near_miss_form'].includes(f.type)) {
                      return renderPreviewForm(f.type);
                    }
                    return null;
                  }}
                </Form.Item>
              </Col>
            </Row>
            )}
            <SelectFromLibraryModal
              visible={libraryPickerVisible}
              onCancel={() => setLibraryPickerVisible(false)}
              onSelect={handleSelectFromLibrary}
              categories={formCategories}
              initialCategoryId={selectedCategoryId}
            />
            <SchemaPreviewModal
              visible={schemaPreview.visible}
              form={schemaPreview.form}
              onCancel={() => setSchemaPreview({ visible: false, form: null })}
            />
            {builderVisible && builderSeed && (
              <LibraryFormBuilderDrawer
                visible={builderVisible}
                // Seed with the current effective schema (prior local edits if any,
                // else the selected template). Deliberately NO `id` — the builder
                // seeds from schema_json alone, so it can never target/overwrite the
                // library template. Property mode also hides Type/Category/Published.
                form={builderSeed}
                // The seed carries no id (above); pass the saved form's id separately
                // so the builder can resolve its source template — for protected-field
                // locks and "Reset to template default". Read-only use.
                formId={dataForm && dataForm.id ? dataForm.id : null}
                mode="property"
                propertyId={props.propertyId}
                // Keep the standalone copy in sync, then persist. When the form
                // already exists, the builder's Save actually saves it (schema-only
                // update). For a not-yet-created form, it's captured locally and
                // written when the Add Form is submitted.
                saveFn={(builderData) => {
                  const baked = bakeHostDefaults(builderData.schema_json, propertyHosts);
                  setEditedSchema({ name: builderData.name, schema_json: baked });
                  if (dataForm && dataForm.id) {
                    // Targeted schema-only update — no submission side effects.
                    return formService.updateSchema(dataForm.id, { schema_json: baked });
                  }
                  return Promise.resolve({ code: '0000' });
                }}
                onSaved={() => { if (dataForm && dataForm.id && !props.fromProperty && props.updateFormData) { props.updateFormData(); } }}
                onClose={() => setBuilderVisible(false)}
              />
            )}
            <Row>
              <Col xs={{span: 24}} md={{span: 11}}>
                <Form.Item
                  name={['form', 'is_checkin_form']}
                  className="isoInputWrapper"
                  valuePropName="checked"
                  hidden={!isLegacyForm}
                >
                  <Checkbox
                      disabled={
                        dataForm.is_public == 1 ||
                        currentUser.id == dataForm.user_id ||
                        !dataForm.id
                        ? false
                        : true}
                    >
                      <IntlMessages id="formPage.modal.isCheckinForm" />
                    </Checkbox>
                </Form.Item>
              </Col>
              <Col xs={{span: 24}} md={{span: 11, offset: 2}}>
                <Form.Item
                  name={['form', 'is_online']}
                  className="isoInputWrapper"
                  valuePropName="checked"
                >
                  <Switch checkedChildren="Online" unCheckedChildren="Offline"/>
                </Form.Item>
              </Col>
            </Row>
            {((currentUser.id == dataForm.user_id && dataForm.type === 'self_create' && dataForm) || !dataForm.id) && <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) => {
                return prevValues['form'];
              }}
            >
              {({ getFieldValue }) => {
                if(getFieldValue('form')){
                  if(getFieldValue('form').type === "self_create"){
                    return (
                      <>
                      { getFieldValue('form').is_checkin_form ?
                      <>
                      <Form.Item
                          name={['form', 'meta_data', 'visitor_types']}
                          className="isoInputWrapper"
                          label={<IntlMessages id="formPage.modal.visitorTypes" />}
                          rules={[
                            {
                              required: true,
                              message: 'This field is required',
                            },
                          ]}
                        >
                            {renderOptionVisitorTypes()}
                        </Form.Item>
                        <Form.Item
                            name={['form', 'meta_data', 'is_hosts_enabled']}
                            className="isoInputWrapper"
                            valuePropName="checked"
                          >
                            <Checkbox>
                                <IntlMessages id="formPage.modal.enableHosts" />
                              </Checkbox>
                          </Form.Item>

                          <Form.Item
                            name={['form', 'meta_data', 'required_visitor_types_for_hosts']}
                            className="isoInputWrapper"
                            label={<IntlMessages id="formPage.modal.hostSelectionRequired" />}
                            rules={[]}
                          >
                              {renderOptionVisitorTypesForHosts()}
                          </Form.Item>
                        </>
                      : null}
                      <Form.Item 
                        name={['form', 'survey_title']}
                        className="isoInputWrapper" 
                        label={<IntlMessages id="formPage.modal.surveyTitle" />}
                        rules={[
                          {
                            required: true,
                            message: 'This field is required',
                          },
                        ]}
                      >
                        <Input size="large" placeholder="Input survey title" />
                      </Form.Item>
                      <Form.Item 
                        name={['form', 'survey_description']} 
                        className="isoInputWrapper"
                        label={<IntlMessages id="formPage.modal.surveyDescription" />}
                        rules={[
                          {
                            required: true,
                            message: 'This field is required',
                          },
                        ]}
                      >
                         <Input.TextArea />
                      </Form.Item>
                      {!dataForm.id ? <Form.List name={['form', 'survey_question']} label={<IntlMessages id="formPage.modal.surveyQuestions" />}>
                        {(fields, { add, remove }) => (
                          <>
                            {fields.map(({ key, name, fieldKey, ...restField }) => (
                              <>
                                <Card 
                                  title={`Question ${name+1}`}
                                  extra={<MinusCircleOutlined onClick={() => handleRemove(remove, name)} />}
                                >
                                    <QuestionFields
                                      key={key}
                                      name={name}
                                    />
                                    {/* <Form.Item
                                      {...restField}
                                      name={[name, 'title']}
                                      fieldKey={[fieldKey, 'title']}
                                      rules={[{ required: true, message: 'This field is required' }]}
                                    >
                                      <Input.TextArea placeholder="Title" />
                                    </Form.Item>
                                    <Form.Item
                                      {...restField}
                                      name={[name, 'question_type']}
                                      fieldKey={[fieldKey, 'question_type']}
                                      rules={[{ required: true, message: 'This field is required' }]}
                                    >
                                      {renderOptionsSurveyQuestion(name)}
                                    </Form.Item>
                                    {
                                      surveyQuestionType[name] && (
                                        renderQuestionFields(surveyQuestionType[name], name, fieldKey, restField)
                                      )
                                    }

                                    { renderResponseConditionsFields(name, fieldKey, restField) }

                                    <Form.Item
                                      {...restField}
                                      name={[name, 'meta_data', 'question_visibility']}
                                      fieldKey={[fieldKey, 'meta_data', 'meta_data']}
                                      rules={[{ required: getFieldValue('form').is_checkin_form ? true :false, message: 'This field is required' }]}
                                    >
                                      {renderVisibilityOptions(name)}
                                    </Form.Item> */}
                                </Card>
                              </>
                            ))}
                            <Form.Item>
                              <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                                Add Question
                              </Button>
                            </Form.Item>
                          </>
                        )}
                      </Form.List> : <Question formId={dataForm.id} />}
                      </>
                    )
                  }
                }
              }}
            </Form.Item>}
            <br/>
            {(currentUser.id != dataForm.user_id && dataForm.id) &&
             renderFormTemplate(dataForm.type)
            }
            {(currentUser.id != dataForm.user_id && dataForm.id && !(['self_create', 'pdf_upload']?.includes(dataForm.type)) && showFinalScreen)
              &&
              <FinalScreen />
            }
            {currentUser.id == dataForm.user_id && <>
                <b><IntlMessages id="formPage.modal.userAgreeListTitle" /></b>
                {
                  isSchemaForm ? (
                    // Phase 07 — dynamic (schema) forms: list every submission
                    // (registered users + public visitors) by time; View Result
                    // opens what that person submitted.
                    <AntdTable
                      className="result-list-table"
                      rowKey="key"
                      size="small"
                      columns={schemaSubmissionColumns}
                      dataSource={groupedSchemaSubmissions}
                      pagination={{ pageSize: 8 }}
                      locale={{ emptyText: 'No submissions yet' }}
                    />
                  ) : (
                    <Box
                      id="containerBoxResultList"
                      style={{ height: "200px", overflow: "auto" }}
                    >
                      <Table 
                        className="result-list-table"
                        columns={columns} 
                        rows={getDataSource()}
                        containerId="containerBoxResultList"
                        showPagination={false}
                        rowSize={99999}
                      />
                    </Box>
                  )
                }
                <ViewSurveyResultModal
                  visibleViewSurveyResult={visibleViewSurveyResult}
                  cancelViewSurveyResult={cancelViewSurveyResult}
                  surveyData={surveyResult}
                  type={surveyResult?.form?.type}
                />
              <hr/>
            </>
            }
          </Col>
          {(currentUser.id == dataForm.user_id || !dataForm.id || isPropertyManager) && 
          <Col xs={{span: 24}} md={{span: 9, offset: 1}}>
            <h3>{<IntlMessages id="formPage.modal.userShare" />}</h3>
            <Form.Item
              name={['form', 'is_share_all']}
              className="isoInputWrapper"
              valuePropName="checked"
            >
              <Checkbox onChange={onChangeCheckBox} 
              disabled={(dataForm.is_public == 1 || currentUser.id == dataForm.user_id || !dataForm.id || isPropertyManager) ? false : true}>{<IntlMessages id="formPage.modal.shareAll" />}</Checkbox>
            </Form.Item>
            <br/>
            <Form.Item
              name={['form', '']}
              className="isoInputWrapper"
            >
              <div className="scrollable-checkbox-group" id="containerBoxUserList">
                <Checkbox.Group 
                  options={userProperty} 
                  disabled={userChecked} 
                  onChange={onUserListChange} 
                  value={userInviteList}
                  style={{ width: '100%' }}
                />
              </div>
            </Form.Item>
            <br/>
            <h3>{<IntlMessages id="formPage.modal.userInvite" />}</h3>
            <br/>
            <Form.Item
              name={['form', 'user_email']}
              className="isoInputWrapper"
              rules={[
                {
                  type: 'email',
                  message: 'The input is not valid Email',
                },
                () => ({
                  validator(rule, value) {
                    if(value)
                      return userService.checkEmailExistsInProperty(value, props.propertyId);
                    else
                      return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input className="pac-target-input" size="large" placeholder="Input user email"/>
            </Form.Item>
            {dataForm.id && dataForm.public_form_url && isShowQr && <>
            <br/>
            <h3>{<IntlMessages id="formPage.modal.qrCodeTitle" />}</h3>
            <br/>
            <div className="form-qr-area">
              <QRCode value={dataForm.public_form_url} />
              <Paragraph copyable>{dataForm.public_form_url}</Paragraph>
            </div>
            </>
            }
          </Col>
        }
        
        </Row>

      </Form>
      <VisitorModal
        visibleVisitorModal={visibleVisitorModal}
        cancelModal={canceVisitorlModal}
        propertyId={activePropertyId}
        editedVisitor={visitor}
        updateVisitorData={getVisitorForms}
      />
      {
        visibleCheckinUserProfileModal && 
          <CheckinUserProfileModal
            formId={props.formData ? props.formData.id : null}
            userId={checkinUserId}
            isVisible={visibleCheckinUserProfileModal}
            cancelModal={cancelCheckinUserProfileModal}
          />
      }
    </FormModalWrapper>
  );
}

export default FormModal;
